var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabsLayout',[_c('ElTabPane',{attrs:{"name":"prewarnrules","label":"预警管理列表"}}),(_vm.$route.name === 'prewarnadd')?_c('ElTabPane',{attrs:{"name":"prewarnadd","label":`新增预警规则`}}):_vm._e(),(_vm.$route.name === 'prewarnedit')?_c('ElTabPane',{attrs:{"name":"prewarnedit","label":`修改预警规则`}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }